const typographyFormService = {
  true: 'Nuevo Servicio',
  false: 'Detalles del Servicio',
  signature: 'FIRMA',
  signatures: 'FIRMAS',
  signatureLabel: 'Firma',
  attachFiles: 'ADJUNTAR ARCHIVOS',
  addSignature: 'Agregar Firma',
  addSignatures: 'Agrega firmas al servicio',
  mandatorySignature: 'La firma es obligatoria para este servicio',
  complement: 'Complemento',
}

export default typographyFormService;
